import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  BUILDING_FORM_FIELD_NAME_IBAN,
  BUILDING_FORM_IBAN_FIELD_MAX_LENGTH,
} from '../../BuildingForm.constants'

import { getNextValue } from './IBANField.utils'

function IBANField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Building.IbanLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getNextValue}
      inline={isMobileScreenSize}
      maxLength={BUILDING_FORM_IBAN_FIELD_MAX_LENGTH}
      name={BUILDING_FORM_FIELD_NAME_IBAN}
      placeholder={t('Building.IbanPlaceholderKey')}
    />
  )
}

export default IBANField
